import React, { FC } from 'react';

import { t } from 'state/intl/translations';
import { ICartEntryType } from 'state/loyalty/in-restaurant-redemption';

import RewardRedemptionIncrementor from './reward-redemption-incrementor';
import { Badge, BadgeWrapper, Container } from './styled';
import { BadgeAndIncrementorProps } from './types';

const BadgeAndIncrementor: FC<React.PropsWithChildren<BadgeAndIncrementorProps>> = ({
  cartEntry,
}) => {
  const isDetailsReward = cartEntry.type === ICartEntryType.REWARD;

  return (
    <Container>
      <BadgeWrapper testID="badge" $orange={isDetailsReward}>
        <Badge>{isDetailsReward ? t('reward') : t('offer')}</Badge>
      </BadgeWrapper>
      {cartEntry.type === ICartEntryType.REWARD && (
        <RewardRedemptionIncrementor cartEntry={cartEntry} />
      )}
    </Container>
  );
};

export default BadgeAndIncrementor;
